let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4HLKJ")).then(() => parcelRequire('dN3M2'));